import React from 'react';
import { CONTACTS } from '../../../../config/contacts';

interface WhatsAppCTAProps {
  message: string;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const WhatsAppCTA: React.FC<WhatsAppCTAProps> = ({ message, children, className = 'lp-btn lp-btn--primary', id }) => (
  <a
    href={CONTACTS.whatsapp.getUrl(message)}
    className={className}
    id={id}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Agendar demonstração via WhatsApp"
  >
    <i className="fab fa-whatsapp" aria-hidden="true" />
    {children}
  </a>
);

export default WhatsAppCTA;
